import { z } from 'zod';

export const creditSourceSchema = z.enum([
  'REMITTANCE',
  'MANUAL',
  'EXTERNAL_PAYMENT',
]);

export const creditSchema = z.object({
  id: z.guid(),
  siteID: z.guid(),
  providerID: z.guid(),
  amount: z.string(),
  date: z.coerce.date(),
  description: z.string().nullable().optional(),
  filename: z.string().nullable().optional(),
  remittanceID: z.guid().nullable().optional(),
  payorID: z.guid().nullable(),
  source: creditSourceSchema.nullable().optional(),
});
